import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useApp } from '../context/AppContext';
import SplashScreen from './SplashScreen';
import LandingPage from './LandingPage';
import WelcomeScreen from './WelcomeScreen';
import LoginScreen from './LoginScreen';
import SignupScreen from './SignupScreen';
import CustomerLogin from '../screens/customer/CustomerLogin';
import AdminLogin from '../screens/admin/AdminLogin';
import AdminDashboard from '../screens/admin/AdminDashboard';
import AdminCategory from '../screens/admin/AdminCategory';
import AdminProduct from '../screens/admin/AdminProduct';
import AdminTable from '../screens/admin/AdminTable';
import AdminOrders from '../screens/admin/AdminOrders';
import AdminCustomers from '../screens/admin/AdminCustomers';
import AdminCustomerBilling from '../screens/admin/AdminCustomerBilling';
import CustomerBillingHistory from '../screens/admin/CustomerBillingHistory';
import AdminProductList from '../screens/admin/AdminProductList';
import AdminCategoryList from '../screens/admin/AdminCategoryList';
import AdminReports from '../screens/admin/AdminReports';
import AdminSettings from '../screens/admin/AdminSettings';
import CustomerHome from '../screens/customer/CustomerHome';
import CustomerCategories from '../screens/customer/CustomerCategories';
import CustomerProducts from '../screens/customer/CustomerProducts';
import CustomerTrack from '../screens/customer/CustomerTrack';
import CustomerHistory from '../screens/customer/CustomerHistory';
import CustomerProfile from '../screens/customer/CustomerProfile';
import CustomerEditProfile from '../screens/customer/CustomerEditProfile';
import CustomerCheckout from '../screens/customer/CustomerCheckout';
import CustomerPayBill from '../screens/customer/CustomerPayBill';
import CustomerTableSelection from '../screens/customer/CustomerTableSelection';

const AppRouter: React.FC = () => {
  const { user, isLoading } = useAuth();
  const { currentScreen, setCurrentScreen, showSplash, setShowSplash } = useApp();

  useEffect(() => {
    if (showSplash) {
      const timer = setTimeout(() => {
        setShowSplash(false);
        // Redirect to landing page first
        setCurrentScreen('landing');
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [showSplash, setCurrentScreen, setShowSplash]);

  if (isLoading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  if (showSplash) {
    return <SplashScreen />;
  }

  // Handle landing, welcome and login screens
  if (currentScreen === 'landing') {
    return <LandingPage />;
  }

  if (currentScreen === 'welcome') {
    return <WelcomeScreen />;
  }
  
  if (currentScreen === 'customer-login') {
    return <CustomerLogin />;
  }
  
  if (currentScreen === 'admin-login') {
    return <AdminLogin />;
  }
  
  if (currentScreen === 'login') {
    return <LoginScreen />;
  }
  
  if (currentScreen === 'signup') {
    return <SignupScreen />;
  }

  // Application screens
  switch (currentScreen) {
    case 'admin-dashboard':
      return <AdminDashboard />;
    case 'admin-category':
      return <AdminCategory />;
    case 'admin-product':
      return <AdminProduct />;
    case 'admin-table':
      return <AdminTable />;
    case 'admin-orders':
      return <AdminOrders />;
    case 'admin-customers':
      return <AdminCustomers />;
    case 'admin-customer-billing':
      return <AdminCustomerBilling />;
    case 'customer-billing-history':
      return <CustomerBillingHistory />;
    case 'admin-product-list':
      return <AdminProductList />;
    case 'admin-category-list':
      return <AdminCategoryList />;
    case 'admin-reports':
      return <AdminReports />;
    case 'admin-settings':
      return <AdminSettings />;
    case 'customer-home':
      return <CustomerHome />;
    case 'customer-categories':
      return <CustomerCategories />;
    case 'customer-products':
      return <CustomerProducts />;
    case 'customer-checkout':
      return <CustomerCheckout />;
    case 'customer-track':
      return <CustomerTrack />;
    case 'customer-history':
      return <CustomerHistory />;
    case 'customer-profile':
      return <CustomerProfile />;
    case 'customer-edit-profile':
      return <CustomerEditProfile />;
    case 'customer-paybill':
      return <CustomerPayBill />;
    case 'customer-table-selection':
      return <CustomerTableSelection />;
    default:
      return <LandingPage />;
  }
};

export default AppRouter;
